import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { Debounce } from 'lodash-decorators'

import TranslationJobModel from '@/views/Language/models/translationJob'
import StringGroupModel from '@/views/Language/models/stringGroup'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import AddButton from '@/_components/button/add/add.vue'
import TranslationJob from '@/views/Language/components/translationJob/translationJob.vue'
@Component({
    components: { ToolbarComponent, AddButton, TranslationJob },
})
export default class TranslationJobs extends Mixins<MixinInterface>() {
    get token() {
        return this.$route.params.token
    }

    get hasAccess() {
        return this.token || this.isSuperuser
    }

    loading = false

    stringGroups: Array<StringGroupModel> = []
    translationJobs: Array<TranslationJobModel> = []

    get translationJobsFiltered() {
        return this.searchTerm
            ? this.translationJobs?.filter((translationJob) =>
                  translationJob.name
                      .toString()
                      .toLowerCase()
                      .includes(this.searchTerm.toString().toLowerCase())
              )
            : this.translationJobs
    }

    get searchTerm() {
        return this.$store.getters.translationJobSearchTerm
    }

    @Debounce(200)
    set searchTerm(str: string) {
        this.$store.commit('translationJobSearchTerm', str)
    }

    async initPost() {
        await TranslationJobModel.initPost(null, this.translationJobs, this.stringGroups)
        this.translationJobs = await TranslationJobModel.getAllTranslationJobs()
    }

    async mounted() {
        this.loading = true
        await this.reload()
        this.loading = false
    }

    async reload() {
        this.loading = true
        this.stringGroups = await StringGroupModel.getAllStringGroups(this.token)
        this.translationJobs = await TranslationJobModel.getAllTranslationJobs(this.token)
        this.loading = false
    }
}
